<template>
    <v-card-text class="narrow-container">
        <v-form @keyup.native.enter="onReset">
            <v-text-field
                v-model="form.email"
                :error-messages="form.$errors.email"
                label="Enter your email adress"
                type="email"
                outlined
                @blur="form.validate('email')"
                @input="delete form.$errors.email"
            />

            <v-tooltip v-model="showPasswordTooltip" content-class="password-tooltip" right>
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="form.password"
                        :error-messages="form.$errors.password"
                        label="Password"
                        type="password"
                        outlined
                        required
                        v-bind="attrs"
                        v-on="on"
                        @blur="
								form.validate('password');
								showPasswordTooltip = false;
							"
                        @input="delete form.$errors.password"
                        @focus="showPasswordTooltip = true"
                    />
                </template>
                <div class="pa-5">
                    <span class="d-block frontpage-text mb-4"
                          :class="{ 'text-decoration-line-through': passValidation.uppercase }"
                    >
                        One uppercase letter
                    </span>
                    <span class="d-block frontpage-text mb-4"
                          :class="{ 'text-decoration-line-through': passValidation.lowercase }"
                    >
                        One lowercase letter
                    </span>
                    <span class="d-block frontpage-text mb-4"
                          :class="{ 'text-decoration-line-through': passValidation.number }"
                    >
                        One number
                    </span>
                    <span class="d-block frontpage-text mb-4"
                          :class="{ 'text-decoration-line-through': passValidation.specialChar }"
                    >
                        One special character
                    </span>
                    <span class="d-block frontpage-text"
                          :class="{ 'text-decoration-line-through': passValidation.length }"
                    >8+ characters
                    </span>
                </div>
            </v-tooltip>

            <v-text-field
                v-model="form.repeatPassword"
                :error-messages="form.$errors.repeatPassword"
                label="Repeat new password"
                type="password"
                outlined
                required
                @blur="form.validate('repeatPassword')"
                @input="delete form.$errors.repeatPassword"
            />

            <v-btn color="primary" :loading="form.$busy" large depressed block rounded @click="onReset">
                Reset password
            </v-btn>
        </v-form>
    </v-card-text>
</template>

<script>
import * as rules from "vuelidate/lib/validators";

export default {
    name: "PasswordReset",

    created() {
        if (!this.$route.query.token) {
            this.$router.push({ name: "ForgotPassword" });
        }
    },

    computed: {
        passValidation() {
            return {
                uppercase: this.form.password ? /[A-Z]/.test(this.form.password) : false,
                lowercase: this.form.password ? /[a-z]/.test(this.form.password) : false,
                number: this.form.password ? /[0-9]/.test(this.form.password) : false,
                specialChar: this.form.password ? /[*.!@#$%^&(){}[:;<>,.?~_/+=|]/.test(this.form.password) : false,
                length: this.form.password ? /^.{8,}$/.test(this.form.password) : false,
            };
        },
    },

    data() {
        return {
            errors: [],
            showPasswordTooltip: false,
            submitted: false,
            form: new Form(this, "form", {
                email: null,
                token: this.$route.query.token,
                password: null,
                repeatPassword: null,
            }),
        };
    },

    validations: {
        form: {
            email: { email: rules.email, required: rules.required },
            password: {
                required: rules.required,
                password: rules.helpers.regex("password", /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[*.!@#$%^&(){}[:;<>,.?~_/+=|]).{8,32}$/),
            },
            repeatPassword: { sameAs: rules.sameAs("password") },
        },
    },

    methods: {
        onReset() {
            if (!this.form.validate()) return;

            this.$apiService
                .post("password/reset", this.form)
                .then(response => {
                    this.submitted = true;
                    this.$snackbar(response.data.message, "success");
                    setTimeout(() => {
                        this.$router.push({ name: "login" });
                    }, 2000);
                })
                .catch(err => {
                    this.$snackbar("Password reset failed. Please try again.", "error");
                });
        },
    },
};
</script>
